import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdmissionComponent } from 'src/app/view/admission/admission.component';
import { FeeComponent } from 'src/app/view/admission/fee/fee.component';
import { HoursComponent } from 'src/app/view/admission/hours/hours.component';
import { HousesComponent } from 'src/app/view/admission/houses/houses.component';
import { LibraryComponent } from 'src/app/view/admission/library/library.component';
import { MessageToParentComponent } from 'src/app/view/admission/message-to-parent/message-to-parent.component';
import { RouterModule } from '@angular/router';
import { ProcessComponent } from 'src/app/view/admission/process/process.component';
import { AdmssionRoutingModule } from './admission-routing.module';
import { UniformComponent } from 'src/app/view/admission/uniform/uniform.component';
import { EntranceSyllabusComponent } from 'src/app/view/admission/entrance-syllabus/entrance-syllabus.component';
import { EntranceResultComponent } from 'src/app/view/admission/entrance-result/entrance-result.component';
import { FormsModule } from '@angular/forms';
import { SubjectComponent } from 'src/app/view/admission/subject/subject.component';



@NgModule({
  declarations: [
    AdmissionComponent,
    MessageToParentComponent,
    FeeComponent,
    LibraryComponent,
    HoursComponent,
    HousesComponent,
    ProcessComponent,
    UniformComponent,
    EntranceSyllabusComponent,
    EntranceResultComponent,
    SubjectComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    AdmssionRoutingModule,
    FormsModule
  ]
})
export class AdmissionModule { }
